
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gUhBpMGbK1_ZQcm6INej4S3A50xyFRU4FAbGNFy0uIycMeta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexzh2SkDTNtuHPzowasibXnTg2H4Iv60xFMb3g2Xh_iY8Meta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchGuw4g4ucZ3BBGgt4aJpkOOrU5DpmvgFxsZxZeIey0o8Meta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexQoSSfSTpy7K8j8wUGM53rBT_452kt_syJwJ8TOL_HuvpYMeta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93xB36HZgM2PSp0dxb0loDXEI8hyNhvjL23Rjvsq9f8ucMeta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexaM_cc5PoMt1Ui_9hZGPDTf4N0VVC3emiuGg9UKKybcEMeta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93pUfyvPi_6Wj2d6_1FituQOswkPiyx_45_45y5GIflnR4aBsMeta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexbVTvBA5tlH9ljqeoPfPf_45i0lCYt5OS_45KIvb_FcqgUL8Meta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93zFFp07uyP0O2gFm28p1DFZ_456q671NIMmJxr_nS_Bu_45kMeta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexdQ18Sz_45azTdcH_45Y_mggYYKUsp3KiwIAxx_7_45YtQzaGgMeta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexQePvU1FJNCMD80EvXVQjlSctN1ZGYDrca_bK7nXwzxsMeta } from "/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexaM_cc5PoMt1Ui_9hZGPDTf4N0VVC3emiuGg9UKKybcEMeta || {},
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexbVTvBA5tlH9ljqeoPfPf_45i0lCYt5OS_45KIvb_FcqgUL8Meta || {},
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexdQ18Sz_45azTdcH_45Y_mggYYKUsp3KiwIAxx_7_45YtQzaGgMeta || {},
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexQePvU1FJNCMD80EvXVQjlSctN1ZGYDrca_bK7nXwzxsMeta || {},
    component: () => import("/codebuild/output/src3739194879/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]